import { z } from 'zod';
import { getDependentFieldOptionalSchema, getDependentFieldSchema } from '../../../constants/sharedSchemas';

export const communitySchema = {
  required: z.object({
    communitySection: z.object({
      cityPopulation: z.string().min(1, 'City population is required'),
      cityWebsite: z.string().min(1, 'City website is required'),
      region: z.string().min(1, 'Region is required'),
      nearestCity: z.string().min(1, 'Nearest city is required'),
      nearestCityPopulation: z.string().min(1, 'Nearest city population is required'),
      distanceFromCity: z.string().min(1, 'Distance from city is required'),
      communityDescription: z.string().min(1, 'Community description is required'),
      placesAndEvents: z.string().min(1, 'Places of interest is required'),
      areasToAvoid: z.string().min(1, 'Areas to avoid is required'),
    }),
    schoolFamilyInfo: z.object({
      schoolTransport: z.array(z.string()).min(1, 'Please specify'),
      distanceToSchool: z.string().min(1, 'Distance to school is required'),
      specialTransportation: getDependentFieldSchema('frequency', 'yes'),
      contactWithCoach: z.string().min(1, 'Please specify'),
      hostWorksAtSchool: z.string().min(1, 'Please specify'),
      childrenSameSchool: z.string().min(1, 'Please specify'),
      childrenSchoolActivities: z.string().min(1, 'Please specify'),
    }),
  }),
  optional: z.object({
    communitySection: z.object({
      cityPopulation: z.string().optional(),
      cityWebsite: z.string().optional(),
      region: z.string().optional(),
      nearestCity: z.string().optional(),
      nearestCityPopulation: z.string().optional(),
      distanceFromCity: z.string().optional(),
      communityDescription: z.string().optional(),
      placesAndEvents: z.string().optional(),
      areasToAvoid: z.string().optional(),
    }),
    schoolFamilyInfo: z.object({
      schoolTransport: z.array(z.string()).optional(),
      distanceToSchool: z.string().optional(),
      specialTransportation: getDependentFieldOptionalSchema('frequency'),
      contactWithCoach: z.string().optional(),
      hostWorksAtSchool: z.string().optional(),
      childrenSameSchool: z.string().optional(),
      childrenSchoolActivities: z.string().optional(),
    }),
  }),
};

export type CommunityFormValues = z.infer<(typeof communitySchema)['required']> | z.infer<(typeof communitySchema)['optional']>;

export const defaultValues: CommunityFormValues = {
  communitySection: {
    cityPopulation: '',
    cityWebsite: '',
    region: '',
    nearestCity: '',
    nearestCityPopulation: '',
    distanceFromCity: '',
    communityDescription: '',
    placesAndEvents: '',
    areasToAvoid: '',
  },

  schoolFamilyInfo: {
    schoolTransport: [],
    distanceToSchool: '',
    specialTransportation: { value: '', frequency: '' },
    contactWithCoach: '',
    hostWorksAtSchool: '',
    childrenSameSchool: '',
    childrenSchoolActivities: '',
  },
};
